import { getWindowData } from "owa-window-data";
import { isStandaloneMyOutlook } from "./isStandaloneMyOutlook";

// All UI personalization and differences will be driven by isHostAppFeatureEnabled
export function isRunningInMetaOSHub(): boolean {
    return !isStandaloneMyOutlook() && getWindowData()?.location?.pathname.indexOf("/hosted") == 0;
}
